import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      ratings: [],
      expanded: [],
      page: 1,
      total: 0,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nº Chamado',
          align: 'center',
          value: 'numeroChamado',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department',
        },
        {
          text: 'Avaliação',
          align: 'center',
          value: 'rateRanking',
        },
        {
          text: 'Observação',
          align: 'center',
          value: 'rateObs',
        },
        {
          text: 'E-mail',
          align: 'center',
          value: 'email',
        },
        {
          text: 'Solicitante',
          align: 'center',
          value: 'requester',
        },
        {
          text: 'Responsável',
          align: 'center',
          value: 'responsavel',
        },
        {
          text: 'Data Fechamento O.S.',
          align: 'center',
          value: 'closeDate',
        },
      ],
      mobileHeader: [
        {
          text: 'Nº Chamado',
          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Avaliação',
          align: 'center',
          value: 'rateRanking',
        },
      ],
      total: 0,
      ratingCounts: {},
    }
  },
  async created() {
    this.listRatings()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `service_Order_Ratings_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/serviceOrderRatings', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listRatings() {
      this.loading = true
      await this.apiService
        .post('reports/ratingServiceOrder', this.filterProp)
        .then((response) => {
          this.total = response.content.paginated.pager.totalItems
          this.totalPages = response.content.paginated.pager.totalPages
          this.showChart = response.content.paginated.objects.length > 0
          this.ratings = response.content.paginated.objects
          this.ratingCounts = {
            high: response.content.highRating,
            well: response.content.wellRating,
            regular: response.content.regularRating,
            bad: response.content.badRating,
          }
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listRatings()
    },
  },
}
